<template>
  <div>
    <textarea :id="id"></textarea>
  </div>
</template>
<script>
export default {
  name: "ckeditor4",
  props: {
    value: {
      type: String,
      default: "",
    },
    func: {
      type: Function,
      default: function () { },
    },
    disable: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    const self = this;
    self.$store.state.initCk = false;
    // 渲染编辑器
    self.ckeditor = window.CKEDITOR.replace(self.id);

    // 设置初始内容
    self.ckeditor.setData(self.value);

    // 监听内容变更事件
    self.ckeditor.on("change", function () {
      self.$emit("input", self.ckeditor.getData());
    });
    self.ckeditor.on("instanceReady", (evt) => {
      self.func();
    });
    self.ckeditor.on("fileUploadRequest", function (evt) {
      let xhr = evt.data.fileLoader.xhr;
      xhr.withCredentials = false;
      xhr.setRequestHeader("Cache-Control", "no-cache");
      xhr.setRequestHeader("token", `${localStorage.getItem("token")}`);
    });
    // 是否可编辑
    self.disable == true ? document.getElementById(self.id).readOnly = true : document.getElementById("myTextarea").readOnly = false
  },
  data() {
    return {
      id: parseInt(Math.random() * 10000).toString(),
      ckeditor: null,
    };
  },
  watch: {
    // 监听prop的变化，更新ckeditor中的值
    value: function () {
      if (this.value !== this.ckeditor.getData()) {
        this.ckeditor.setData(this.value);
      }
    },
  },
  // 销毁组件前，销毁编辑器
  // beforeDestroy: function() {
  //   self.ckeditor.destroy();
  // }
};
</script>
<style>
.cke_contents {
  height: 500px !important;
}
</style>
